var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayPencilIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(-729.342 -325.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M9,10.533v2.75a.705.705,0,0,0,.705.705h2.75a.705.705,0,0,0,.5-.207l7.531-7.533a1.714,1.714,0,0,0,0-2.426L19.165,2.5a1.718,1.718,0,0,0-2.426,0L9.207,10.039A.705.705,0,0,0,9,10.533ZM18.167,3.5l1.321,1.321a.3.3,0,0,1,.09.212.306.306,0,0,1-.09.216l-.846.846L16.888,4.349l.846-.846A.307.307,0,0,1,18.167,3.5ZM10.41,10.826l5.48-5.48L17.642,7.1l-5.48,5.48H10.41Z",
    transform: "translate(725.65 323.665)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M18.308,9.308a.692.692,0,0,0-.692.692v5.437a2.181,2.181,0,0,1-2.179,2.179H4.563a2.181,2.181,0,0,1-2.179-2.179V4.563A2.181,2.181,0,0,1,4.563,2.385H10A.692.692,0,0,0,10,1H4.563A3.568,3.568,0,0,0,1,4.563V15.437A3.568,3.568,0,0,0,4.563,19H15.437A3.568,3.568,0,0,0,19,15.437V10A.692.692,0,0,0,18.308,9.308Z",
    transform: "translate(728.342 324.666)",
    fill: "#b1b1b1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPencilIcon);
export default __webpack_public_path__ + "static/media/gray-pencil-icon.bc49daedc12731cb1e7b6fa2139e0f6c.svg";
export { ForwardRef as ReactComponent };